export default __webpack_public_path__ + "static/media/icon.fba9d237.svg";